module.exports = __webpack_public_path__ + "static/img/4.b9440f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/sp/4.png
// module id = C/Wx
// module chunks = 0